<div class="page-content-container">
  <ng-content></ng-content>
</div>
